import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const buildSVG = (faIcon: IconDefinition) =>
    encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <g>
            <path fill="#fff" d="${faIcon.icon[4]}"/>
        </g>
    </svg>`);

export const buildRawSVG = (faIcon: IconDefinition, color: string) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <g>
        <path fill="${color}" d="${faIcon.icon[4]}"/>
    </g>
</svg>`;
